const wrappedContractNames: Record<number, string> = {
  1: 'WETH', //mainnet
  10: 'WETH', //optimism
  56: 'WBNB', //bnb
  204: 'WBNB', //opbnb
  137: 'WMATIC', //polygon
  1101: 'WETH ', // zkEVM
  324: 'WETH', //weth
  42161: 'WETH', //arbitrum
  42170: 'WETH', //arbitrum nova
  43114: 'WAVAX', //avalance
  59144: 'WETH',
  999: 'WETH', //zoratestnet
  80002: 'WMATIC', //amoy
  8453: 'WETH', //base
  84532: 'WETH', //base sepolia
  534353: 'WETH', //scrolltestnet
  534352: 'WETH', //scroll
  7777777: 'WETH', //zora
  11155111: 'WETH', //sepolia
  888888888: 'WETH', //ancient8
  28122024: 'WETH', //ancient8 testnet
  68840142: 'WETH', //frametestnet
  168587773: 'WETH', //blast sepolia
  70700: 'WETH', //apex pop
  70800: 'WETH', //apex pop testnet
  81457: 'WETH', //blast
  3776: 'WETH', // astar zkevm,
  17069: 'WETH', // garnet
  690: 'WETH', // redstone
  80084: 'WBERA', // berachain testnet
  666666666: 'WDEGEN', // degen
  660279: 'WXAI', // xai
  1482601649: 'ETH', // nebula
  713715: 'WSEI', // sei testnet
  7560: 'WETH', // cyber
  200901: 'WBTC', // bitlayer
  1329: 'WSEI', // sei
  1993: 'WETH', // b3 testnet
  646: 'WFLOW', // flow previewnet
  70805: 'WETH', // cloud
  13746: 'WTG7T', // game7 testnet
  70701: 'WETH', // boss
  984122: 'WTIA', // forma
  984123: 'WTIA', // forma sketchpad
  8333: 'WETH', // b3
  33139: 'WAPE', // apechain
  33111: 'WAPE', // apechain
  360: 'WETH', // shape
  11011: 'WETH', // shape sepolia
  11124: 'WETH', // abstract testnet
  1946: 'WETH', // minato
  2911: 'WTOPIA', // hychain
  29112: 'WTOPIA', // hychain testnet
  747: 'WFLOW', // flow
  543210: 'WETH', // zero
  43210: 'WETH', // zero testnet
  2741: 'WETH', // abstract
  6900: 'WANIME', // anime testnet
  41454: 'WMON', // monad devnet
  10143: 'WMON', // monad testnet
  2187: 'WG7', //game7
  4654: 'WETH', // creator testnet
  1868: 'WETH', // Soneium
  1516: 'WIP', // Story Odyssey
  57073: 'WETH', // Ink
  80094: 'WBERA', // Berachain
  69000: 'WANIME', // Anime
}
export default wrappedContractNames
